import axios from 'axios';
import { SuluDocument } from '@/logic/cms/sulu';

export default {
  namespaced: true,
  state: {
    content: undefined as any,
  },
  mutations: {
    setContent(state: any, content: SuluDocument) {
      state.content = content;
    },
  },
  actions: {
    async getContent({ commit }: { commit: Function }, params: any) {
      const { route, i18n } = params;
      const locale = i18n.locale.toLowerCase();
      const webspace = { url: `/customer_portal/${locale}` };
      const contentEndpoint = route.name === 'home' ? '' : '/content';
      const contentPath = route.fullPath || '';

      commit('setContent', undefined);
      const { data } = await axios.get(
        `${process.env.VUE_APP_CMS_BASE_PATH}/api${webspace.url}${contentEndpoint}`,
        {
          params: { path: contentPath },
        },
      );
      commit('setContent', data);
    },
  },
};
